import {
    post,
    get,
    phpPost
} from "../util/crmAxios";
import { getBasicUrls } from "../util/config";
const crmApi = getBasicUrls().crmApi
const schoolm = getBasicUrls().schoolm
//
export const getRefundHoursApplyList = (params) => post('erp/student/getRefundHoursApplyList', params)

//
export const refund_hours_apply_list = (params) => phpPost('/os/refund_hours_apply_list', params)

// 学员智适应学情
export const learningConditionList = (params) => post('/erp/topic/learningConditionList', params);

// 学员智适应知识点明细
export const knowledgePointDetailList = (params) => post('/erp/topic/knowledgePointDetailList', params);

// 打地基时长明细
export const ddjtimesubachievement = (params) => post( schoolm + 'agent/report/ddjtimesubachievement', params);

// 打地基时长明细导出
export const exportddjtimesubachievement = (params) => post(schoolm + 'agent/report/exportddjtimesubachievement', params);

// 打地基明细报表
export const ddjdetailachievement = (params) => post(schoolm + 'agent/report/ddjdetailachievement', params);

// 打地基明细报表导出
export const exportddjdetailachievement = (params) => post(schoolm + 'agent/report/exportddjdetailachievement', params);

// 念念有词使用时长报表
export const nnyctimeachievement = (params) => post(schoolm + 'agent/report/nnyctimeachievement', params);

// 念念有词使用时长报表导出
export const exportnnyctimeachievement = (params) => post(schoolm + 'agent/report/exportnnyctimeachievement', params);

// 用户有效指数统计明细
export const usereffectindexdetailachievement = (params) => post(schoolm + 'agent/report/usereffectindexdetailachievement', params);

// 用户有效指数统计明细导出
export const exportusereffectindexdetailachievement = (params) => post(schoolm + 'agent/report/exportusereffectindexdetailachievement', params);

export const refund_apply_detail = (params) => phpPost('/os/refund_apply_detail', params)

//公告分页查询
export const queryNoticeList = (params) => post('erp/notice/queryNoticeList', params)


//公告详情
export const messageDetail = (params) => get('erp/notice/messageDetail', params)

//校区-课消对账单
export const subjectCostHoursList = (params) => post('erp/school/subjectCostHoursList', params)

//班级课后反馈列表
export const queryFeedbackListByClassScheduleId = (params) => post('erp/teacherfeedback/queryFeedbackListByClassScheduleId', params)

//
//获取socket配置
export const socketConfig = (params) => post('sdk/java/socketConfig', params)

//获取校区学员课时预警列表
export const getStudentSubjectWarningList = (param) => post('erp/warning/getStudentSubjectWarningList', param)

//获取校区课时预警数
export const getStudentWarningHour = () => get('erp/warning/getStudentWarningHour', )
export const setStudentWarningHour = (params) => get('erp/warning/setStudentWarningHour',params )

//获取超级监课校区（运营系统）
export const querySupervisionSchool = (params) => post('erp/teacher/querySupervisionSchool',params )
//监课列表（盘古/松果）
export const querySchoolLists = (params) => post(crmApi + 'crm/common/querySchoolLists',params )

//获取超级监课跳转地址
export const querySuperJumpUrl = (params) => {
    if (params.nw) { //（盘古/松果）
        return post(crmApi + 'crm/common/querySuperJumpUrl',params )
    } else { // （运营系统）
        return post('erp/teacher/querySuperJumpUrl',params )
    }
}

//总部课程列表分页
export const getAllSchoolCourseList = (params) => post('erp/schoolCourse/getAllSchoolCourseList',params)

//Es学习报告查询
export const searchUserReportList = (params) => post('erp/report/searchUserReportList',params)
// 兑换-松子变更记录查询
export const queryExchangeOperateRecords = (params) => post('erp/exchange/queryExchangeOperateRecords',params)
//查询公校
export const queryBaseSchool = params => post(schoolm +'/manage/schoolInfoExtend/queryBaseSchool',params)
//获取用户起航课课程列表
export const queryUserCoursePageList = params => post('/crm/customer/queryUserCoursePageList',params)
//⽤户课程体验课星空任务卡列表
export const queryUserStarModuleList = params => post('/crm/customer/queryUserStarModuleList',params)
// 学科列表
export const getsubjectdictbytype = (params) => post(schoolm + "subjectdict/getsubjectdictbytype", params);
